import React from 'react';
import styles from './killsperweapon.module.css';
import {numberWithCommas} from '../common/utilities';
import { Trans } from 'react-i18next';

export default class KillsPerWeapon extends React.Component{


    /*    
    * sortKPW
        RIFLE_KILL - assault rifle
        SHOT_KILL - sniper
        SMG_KILL - sub machine gun
        HEAVY_KILL - machine gun
        SHOTGUN_KILL - shotgun
        PISTOL_KILL - pistol
        KNIFE_KILL - melee
        DRAW_KILL - grenades

    * @param {INT} counts of weapon kills [rifle, sniper, smg, mg, shotgun, pistol, melee, grenade]
    * @returns {string}
    */
    sortKPW (rifle, sniper, smg, mg, shotgun, pistol, melee, grenade) {

        var myweapons = [
            {
                name: 'Assault Rifles'
                ,kills: rifle
                ,icon: 'icon icon_icon_weapon_assaultrifle'
                ,icon2: 'assaultrifle'
            },
            {
                name: 'Sniper Rifles'
                ,kills: sniper
                ,icon: 'icon icon_icon_weapon_sniper'
                ,icon2: 'sniper'
            },
            {
                name: 'Sub Machine Guns'
                ,kills: smg
                ,icon: 'icon icon_icon_weapon_smg'
                ,icon2: 'smg'
            },
            {
                name: 'Machine Guns'
                ,kills: mg
                ,icon: 'icon icon_icon_weapon_mg'
                ,icon2: 'mg'
            },
            {
                name: 'Shotguns'
                ,kills: shotgun
                ,icon: 'icon icon_icon_weapon_shotgun'
                ,icon2: 'shotgun'
            },
            {
                name: 'Pistols'
                ,kills: pistol
                ,icon: 'icon icon_icon_weapon_pistol'
                ,icon2: 'pistol'
            },
            {
                name: 'Melee'
                ,kills: melee
                ,icon: 'icon icon_icon_weapon_melee'
                ,icon2: 'melee'
            },
            {
                name: 'Grenades'
                ,kills: grenade
                ,icon: 'icon icon_icon_weapon_grenade'
                ,icon2: 'grenade'
            }
        ];

        myweapons.sort(function(a, b) { 
            return a.kills - b.kills;
        })
        
        myweapons.reverse();

        var string = [];

        for(var i in myweapons){

            var stylename = myweapons[i].icon2;
            var myStyle = styles.icon + ' ' + styles[stylename];
            //console.log(myStyle);

            string.push(
                    <div className={styles.row} key={i}>
                        <h5>
                            <span className={myStyle}></span>
                            <Trans>{myweapons[i].name}</Trans>
                        </h5>
                        <h3>{numberWithCommas(myweapons[i].kills)}</h3>
                    </div>
            );
        }
            
        return string; 

    }

    showInt(count = 0 ){
        return (typeof count !== 'undefined') && '' !== count && (parseInt(count, 10) >= 0) ? parseInt(count, 10) : 0;
    }

    render (){

        return (

            <div className={styles.kpw}>
                {this.sortKPW(
                     this.showInt(this.props.rifle)
                    ,this.showInt(this.props.sniper)
                    ,this.showInt(this.props.smg)
                    ,this.showInt(this.props.mg)
                    ,this.showInt(this.props.shotgun)
                    ,this.showInt(this.props.pistol)
                    ,this.showInt(this.props.melee)
                    ,this.showInt(this.props.grenade)
                )}
            </div>

        );
    }
}